import { useState, useEffect } from 'react';
import { useTheme } from 'styled-components';
import ReCAPTCHA from 'react-google-recaptcha';
import { Loader as SharedLoader, computeLoadingProgress } from '@make-software/tg-mini-app-ui';

import LoadingLogo from '@/shared/assets/logos/loading-logo.svg';
import Bg from '@/shared/assets/backgrounds/bg.jpg';

export const UserLoaded = 1;
export const SeasonInfoLoaded = 2;
export const FriendsLoaded = 4;
export const LeaderboardLoaded = 8;
export const HackathonProjectsLoaded = 16;

export const ALL_LOADED = UserLoaded | SeasonInfoLoaded | FriendsLoaded | LeaderboardLoaded | HackathonProjectsLoaded;

const LOADING_FLAGS = [
  { flag: UserLoaded, weight: 20 },
  { flag: FriendsLoaded, weight: 20 },
  { flag: SeasonInfoLoaded, weight: 10 },
  { flag: LeaderboardLoaded, weight: 10 },
  { flag: HackathonProjectsLoaded, weight: 10 },
];

export interface LoaderProps {
  error?: string | null;
  loadingStatus: number;
  onAnimationEnd?: () => void;
  suspicious?: boolean;
  onCaptchaSolved?: (captchaToken: string) => void;
}

export const Loader = ({
  error,
  loadingStatus,
  onAnimationEnd,
  suspicious,
  onCaptchaSolved
}: LoaderProps) => {
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);
  const theme = useTheme();

  useEffect(() => {
    if (captchaToken && captchaToken.length > 0) {
      onCaptchaSolved?.(captchaToken);
    }
  }, [captchaToken]);

  const progress = 40 + Math.round(computeLoadingProgress(loadingStatus, LOADING_FLAGS) * 0.6);

  return (
    <SharedLoader
      barColor={theme.colors.mainRed} //'#fb6f6a'
      progress={progress}
      error={error}
      onAnimationEnd={onAnimationEnd}
      logoSrc={LoadingLogo}
      captchaSlot={
        suspicious ? (
          <ReCAPTCHA
            sitekey={window.config.google_recaptcha_site_key}
            onChange={(token) => setCaptchaToken(token)}
          />
        ) : undefined
      }
      containerStyle={{
        backgroundImage: `url(${Bg})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover'
      }}
    />
  );
};
